import {Component, OnInit, ViewChild} from '@angular/core';
import {ActionsSubject, Store} from '@ngrx/store';
import {Observable } from 'rxjs/index';
import {OPEN_SIGN_IN} from '../../../store/menu/menu.action';
import {AppState} from '../../../store/app.state';
import {CartBeforeLogin, NumberProduct} from '../../../store/reservation/reservation.action';
import {ReservationsService} from '../../service/reservations/reservations.service';
import { ModelStore } from '../../model.store';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss']
})
export class PublicLayoutComponent implements OnInit {

  @ViewChild('authApp')
  public authApp: any;
  controlAuthClass = 'hidden';
  reservationState: Observable<any>;
  dispId: string;

  constructor( 
    private store: Store<AppState>,
    private actionsSubj: ActionsSubject,
    private reservationsService: ReservationsService,
    private modelStore: ModelStore
  ) {
    
    this.reservationState = store.select('reservation');
    actionsSubj.subscribe(data => {
      if (data.type === OPEN_SIGN_IN) {
        this.showAuthForm();
      }
    });
  }

  ngOnInit() {
    this.modelStore.dispensaryObservable.subscribe(dispensary => {
      this.dispId = dispensary['disp_id'];
    });
  }

  showAuthForm() {
    this.authApp.initData();
    this.controlAuthClass = '';
  }

  hideAuthForm() {
    this.controlAuthClass = 'hide';
    let dataProduct = null;
    this.reservationState.subscribe(reservationState => {
      dataProduct = reservationState.data;
    });

    if (dataProduct != null) {
      this.addToCart(dataProduct);
      this.store.dispatch(new CartBeforeLogin({data: null}));
    }
  }

  addToCart(data) {
    let numberItem = 0;
    data['disp_id'] = this.dispId;
    this.reservationsService.addToCart(data).subscribe( rs => {

      if (rs && rs['cart'] ) {
        if (rs && rs['cart']['items']) {
          // numberItem = numberItem + rs['cart']['items'].length;
          rs['cart']['items'].forEach(item => {
            numberItem = numberItem + Number(item.qty);
          });
        }
        if (rs && rs['cart']['deals']) {
          numberItem = numberItem + rs['cart']['deals'].length;
        }
        if (rs && rs['cart']['reward_items']) {
          numberItem = numberItem + rs['cart']['reward_items'].length;
        }
        this.store.dispatch(new NumberProduct({numberProduct: numberItem}));
      }
    });
  }
}
